import script from "./MetadataView.vue?vue&type=script&setup=true&lang=js"
export * from "./MetadataView.vue?vue&type=script&setup=true&lang=js"

import "./MetadataView.vue?vue&type=style&index=0&id=7c3a701d&scoped=true&lang=scss"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-7c3a701d"]])

export default __exports__